import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const HelperText = styled.span`
  color: ${({ theme }) => theme.colors.textSecondary};
  font-family: 'Roboto', sans-serif;
  font-size: 10px;
  font-weight: 500;
  line-height: 12px;
  margin: 7px 0 0 0;
  padding: 0 14px;
`;
